import React, { useState } from 'react';
import Calendar from 'react-calendar';
import { LooseValue } from 'react-calendar/dist/esm/shared/types';
import { useTranslation } from '../../tools/i18n';
import { Picto } from '../Picto';
import { FilterLayout } from './FiltersLayout';
import { ChatBotComponentProps } from './index';

export const StartDate = (props: ChatBotComponentProps) => {
  const { config, callback, initialData, back, requirements } = props;
  const [date, setDate] = useState<LooseValue>(initialData);
  const { t, language } = useTranslation();
  const subtitleKey = `travelPlaner.StartDate.subTitle`;
  const hasSubtitle = t(subtitleKey) !== subtitleKey;

  return (
    <div className="startDate">
      <FilterLayout
        config={config}
        callback={() => callback(date)}
        title={t(`travelPlaner.StartDate.title`)}
        back={back}
        requirements={requirements}
        disabledNext={!date}
        siteConfiguration={props.siteConfiguration}
      >
        {hasSubtitle ? <div className="layoutSubtitle">{t(subtitleKey)}</div> : null}
        <Calendar
          value={date}
          onChange={setDate}
          minDate={new Date()}
          defaultView={config.newUI ? 'year' : 'month'}
          prev2Label={config.newUI ? null : '«'}
          next2Label={config.newUI ? null : '»'}
          prevLabel={config.newUI ? <Picto iconKey="caret-left" /> : '‹'}
          nextLabel={config.newUI ? <Picto iconKey="caret-right" /> : '›'}
          locale={language?.split(/[-_]/)?.[0]}
        />
      </FilterLayout>
    </div>
  );
};
